import { Tabs } from 'src/components';
import { Color } from 'src/constants';

export const PROFILE_PATH = '/profile';
export const TIME_LOG_PATH = '/profile/time-log';

type Props = {
  selected: 'profile' | 'time-log';
};

export default function ProfileTabs({ selected }: Props) {
  return (
    <Tabs
      accentColor={Color.accent}
      tabs={[
        {
          label: 'Profile',
          to: PROFILE_PATH,
          selected: selected === 'profile',
        },
        {
          label: 'Time Log',
          to: TIME_LOG_PATH,
          selected: selected === 'time-log',
        },
      ]}
    />
  );
}
